export default __webpack_public_path__ + "6281dbd2d609ed7ab2d344aee9904b89.svg";